import styled from 'styled-components';

export const MetodeContainer = styled.div`
    height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #4F4D4D;

    @media screen and (max-width: 768px) {
        height: 700px;
    }

    @media screen and (max-width: 480px) {
        height: 900px;
    } 
`;

export const MetodeWrapper = styled.div`
    max-width: 1100px;
    margin: 0 auto;
    align-items: center;
    padding: 0 50px;
`;


export const MetodeH2 = styled.h2`
    font-size: 2.5rem;
    color: #fff;
    margin-bottom: 64px;
    text-align: center;

    @media screen and (max-width: 780px) {
        font-size: 1.5rem;
    }

    @media screen and (max-width: 480px) {
        font-size: 1rem;
    }
`;

export const MetodeP = styled.p`
    font-size: 0.9rem;
    text-align: center;
    color: #fff;
`;
